<br>
<div class="box">

  <h3 class="kozep">
    About
  </h3>

  <p>Ez itt az about page és itt az oldalról fogunk írni.</p>
  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sit amet ante ante. Quisque eu odio feugiat, lacinia orci ac, eleifend est. Morbi scelerisque volutpat augue nec eleifend. Vestibulum vel quam augue. Ut mollis, lacus nec pulvinar egestas, leo ligula semper justo, ut condimentum odio nulla aliquet nibh. Donec condimentum egestas lorem ut imperdiet. Fusce ut consequat elit.</p>
  <p>Sed risus sem, mollis eu pharetra vel, rhoncus nec nibh. Duis sagittis velit a sapien gravida, nec mattis orci maximus. Pellentesque gravida lectus nisl, vitae gravida sem pulvinar eu. Maecenas maximus dui quam, id vehicula quam sagittis id. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam in pulvinar quam. Integer finibus, turpis sed venenatis dignissim, ante massa ultricies dolor, id pretium purus ante vel nisl. In ac tellus vestibulum, mollis risus sed, tempor felis. Etiam in congue lacus, vitae consequat eros.</p>

</div>


<style>

.kozep {
  text-align: center;
}

div.box {
  border: 1px solid #DDD;
  border-radius: 1rem;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  margin-bottom: 1.5rem;
  background-color: #f6f6f6;
}

</style>
